import React, { FunctionComponent } from 'react';
import { useTranslation, withTranslation, WithTranslation } from 'react-i18next';
import { compose } from 'recompose';

interface InProps {
    onChange: (itemsPerPage: number, currentPageNumber: number, sortItemsBy: string, sortItemsOrder: string) => void;

    totalItems: number;
    perPage: number;
    pageNumber: number;
    sortBy: string;
    sortOrder: string;
    sorting?: boolean;
    perPageOptions: Array<{ value: string; name: string }>;
    sortByOptions?: Array<{ value: string; name: string }>;
}

type CustomPaginationProps = InProps & WithTranslation;

const enhance = compose<CustomPaginationProps, InProps>(withTranslation());

const CustomPagination: FunctionComponent<CustomPaginationProps> = ({
    onChange,
    totalItems,
    perPage,
    pageNumber,
    sortBy,
    sortOrder,
    sorting,
    perPageOptions,
    sortByOptions,
}) => {
    const { t } = useTranslation();
    const numberOfPages = Math.ceil(totalItems / perPage);

    const handlePageNumberChange = (target: any) => {
        if (target <= numberOfPages && target > 0) {
            onChange(perPage, target, sortBy, sortOrder);
        }
    };

    const handlePerPageChange = (target: any) => {
        if (target.target.value * pageNumber <= totalItems) {
            onChange(target.target.value, pageNumber, sortBy, sortOrder);
        } else {
            onChange(target.target.value, 1, sortBy, sortOrder);
        }
    };

    const handleSortByChange = (target: any) => {
        onChange(perPage, pageNumber, target.target.value, sortOrder);
    };

    const handleSortOrderChange = (target: any) => {
        onChange(perPage, pageNumber, sortBy, target.target.value);
    };

    const pageNumbers = [];

    const numPages = totalItems % perPage === 0 ? totalItems / perPage : numberOfPages;
    for (let i = 1; i <= numPages; i++) {
        pageNumbers.push(i);
    }

    return (
        <table className="barcode" style={{ height: '60px' }}>
            <tbody>
                <tr style={{ backgroundColor: 'transparent'}}>
                    <th style={{ width: '2048px', verticalAlign: 'bottom' }}>
                        <label className="label-pagination">{t('common.totalItems', { totalItems })}</label>
                        <label className="label-pagination">{t('common.perPage')}</label>
                        <select
                            className="report-input"
                            style={{backgroundColor:"white", border: ''}}
                            name="perPage"
                            id="perPage"
                            onChange={handlePerPageChange}
                            value={perPage.toString()}
                        >
                            {perPageOptions.map((option: { value: string; name: string }) => {
                                return (
                                    <option key={option.value} value={option.value}>
                                        {option.name}
                                    </option>
                                );
                            })}
                        </select>
                        {sorting && sortByOptions && (
                                <>
                                    <label className="label-pagination">{t('common.sortBy')}</label>
                                    <select
                                        className="report-input"
                                        name="sortBy"
                                        id="sortBy"
                                        onChange={handleSortByChange}
                                        defaultValue={sortBy}
                                    >
                                        {sortByOptions.map((option: { value: string; name: string }) => {
                                            return (
                                                <option key={option.value} value={option.value}>
                                                    {option.name}
                                                </option>
                                            );
                                        })}
                                    </select>
                                    <label className="label-pagination">{t('common.sortOrder')}</label>
                                    <select
                                        className="report-input"
                                        name="sortBy"
                                        id="sortBy"
                                        onChange={handleSortOrderChange}
                                        defaultValue={sortOrder}
                                    >
                                        <option value="asc">Asc</option>
                                        <option value="desc">Desc </option>
                                    </select>
                                </>
                            )}
                    </th>
                    <td>
                        <ul className="custom-pagination">
                            <li onClick={() => handlePageNumberChange(pageNumber > 1 ? pageNumber - 1 : pageNumber)}>
                                {'<'}
                            </li>
                            {pageNumbers.map((num) => (
                                <li
                                    key={num}
                                    className={pageNumber === num ? 'active' : ''}
                                    onClick={() => handlePageNumberChange(num)}
                                >
                                    {num}
                                </li>
                            ))}
                            <li
                                onClick={() =>
                                    handlePageNumberChange(pageNumber < numPages ? pageNumber + 1 : pageNumber)
                                }
                            >
                                {'>'}
                            </li>
                        </ul>
                    </td>
                </tr>
            </tbody>
        </table>
    );
};

export default enhance(CustomPagination);
